import { useRef, useCallback } from "react";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import { toast } from "sonner";
import api from "@/lib/api";
import { Image as ImageIcon, LinkSimple } from "@phosphor-icons/react";

const MODULES = {
  toolbar: [
    [{ header: [2, 3, false] }],
    ["bold", "italic", "underline"],
    [{ color: [] }, { background: [] }],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ align: [] }],
    ["link", "clean"],
  ],
};

const abs = (url) =>
  url && url.startsWith("/") ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url;

export function RichTextEditor({ value, onChange }) {
  const quillRef = useRef(null);
  const fileRef = useRef(null);

  const insertImage = useCallback((url) => {
    const editor = quillRef.current?.getEditor?.();
    if (!editor) return;
    const range = editor.getSelection(true) || { index: editor.getLength() };
    editor.insertEmbed(range.index, "image", url, "user");
    editor.setSelection(range.index + 1);
  }, []);

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await api.post("/uploads/image", fd, { headers: { "Content-Type": "multipart/form-data" } });
      insertImage(abs(data.url));
      toast.success("Image added");
    } catch {
      toast.error("Image upload failed");
    }
  };

  const addUrl = () => {
    const url = window.prompt("Paste the image URL (https://…)");
    if (!url) return;
    if (/^https?:\/\//i.test(url.trim())) insertImage(url.trim());
    else toast.error("Enter a valid https:// image URL");
  };

  return (
    <div data-testid="rich-text-editor" className="gv-editor">
      <div className="flex items-center gap-2 mb-2">
        <button type="button" data-testid="editor-upload-image" onClick={() => fileRef.current?.click()}
          className="inline-flex items-center gap-1.5 text-xs font-medium px-2.5 py-1.5 rounded-md border border-border hover:bg-secondary transition-colors">
          <ImageIcon size={14} /> Upload image
        </button>
        <button type="button" data-testid="editor-image-url" onClick={addUrl}
          className="inline-flex items-center gap-1.5 text-xs font-medium px-2.5 py-1.5 rounded-md border border-border hover:bg-secondary transition-colors">
          <LinkSimple size={14} /> Image URL
        </button>
        <input ref={fileRef} type="file" accept="image/*" hidden onChange={onFile} />
      </div>
      <ReactQuill ref={quillRef} theme="snow" value={value || ""} onChange={onChange} modules={MODULES} />
    </div>
  );
}
